export const DicomSeriesEndpoints = {
  namespaced: true,

  state: {
    endpoints: {},
    loading: {},
    saving: {},
  },

  getters: {
    /* eslint-disable indent */
    getEndpointsForSeries:
      ({ endpoints }) =>
      (imageId) =>
        endpoints[imageId] ?? [],
    isSaving:
      ({ saving }) =>
      (imageId) =>
        saving[imageId],
    isBusy:
      ({ loading, saving }) =>
      (imageId) =>
        loading[imageId] || saving[imageId],
  },

  mutations: {
    setLoading(state, { id, loading }) {
      state.loading = { ...state.loading, [id]: loading };
    },
    setSaving(state, { id, saving }) {
      state.saving = { ...state.saving, [id]: saving };
    },
    setEndpointsForSeries(state, { id, endpoints }) {
      state.endpoints = { ...state.endpoints, [id]: endpoints };
    },
  },

  actions: {
    async loadTagsForSeries({ commit }, { repository, project, imageData }) {
      const { id } = imageData;
      commit('setLoading', { id, loading: true });

      try {
        const response = await this._vm.$api('repositories.projects.dicom.series.endpoints.index', {
          repository,
          project,
          dicomImage: id,
        });

        commit('setEndpointsForSeries', { id, endpoints: response.data?.data ?? [] });
      } catch (e) {
        console.error(e);
      }

      commit('setLoading', { id, loading: false });
    },

    async addTagToSeries({ commit }, { repository, project, imageData, data }) {
      const { id } = imageData;
      commit('setSaving', { id, saving: true });

      try {
        const response = await this._vm.$api(
          'repositories.projects.dicom.series.endpoints.store',
          {
            repository,
            project,
            dicomImage: id,
          },
          data
        );
        commit('setEndpointsForSeries', { id, endpoints: response?.data?.data ?? [] });
      } catch (e) {
        console.error(e);
      }

      commit('setSaving', { id, saving: false });
    },

    async removeTagFromSeries({ commit }, { repository, project, imageData, tagId }) {
      const { id } = imageData;
      commit('setSaving', { id, saving: true });

      try {
        const response = await this._vm.$api('repositories.projects.dicom.series.endpoints.destroy', {
          repository,
          project,
          dicomImage: id,
          tag: tagId,
        });

        commit('setEndpointsForSeries', { id, endpoints: response?.data?.data ?? [] });
      } catch (e) {
        console.error(e);
      }

      commit('setSaving', { id, saving: false });
    },
  },
};
